<div class="report-filters">
  <mat-form-field>
    <mat-label>START</mat-label>
    <input matInput type="date" [(ngModel)]="startDate">
  </mat-form-field>
  <mat-form-field>
    <mat-label>END</mat-label>
    <input matInput type="date" [(ngModel)]="endDate">
  </mat-form-field>
  <button mat-raised-button type="button" (click)="load()">LOAD REPORT</button>
</div>

<div *ngIf="loading">
  <h3 style="text-align:center;">LOADING REPORT</h3>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>

<table mat-table [dataSource]="rows" class="mat-elevation-z2" *ngIf="!loading" style="width:100%">
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>EVENT</th>
    <td mat-cell *matCellDef="let row">{{ row.name }}</td>
  </ng-container>
  <ng-container matColumnDef="vendorName">
    <th mat-header-cell *matHeaderCellDef>VENDOR / LINE</th>
    <td mat-cell *matCellDef="let row">{{ row.vendorName }}</td>
  </ng-container>
  <ng-container matColumnDef="framesSold">
    <th mat-header-cell *matHeaderCellDef>FRAMES SOLD</th>
    <td mat-cell *matCellDef="let row">{{ row.framesSold }}</td>
  </ng-container>
  <ng-container matColumnDef="grossNewBusiness">
    <th mat-header-cell *matHeaderCellDef>GROSS NEW BUSINESS</th>
    <td mat-cell *matCellDef="let row">{{ money(row.grossNewBusiness) }}</td>
  </ng-container>
  <ng-container matColumnDef="discountAmount">
    <th mat-header-cell *matHeaderCellDef>DISCOUNT</th>
    <td mat-cell *matCellDef="let row">{{ money(row.discountAmount) }}</td>
  </ng-container>
  <ng-container matColumnDef="salesAfterDiscount">
    <th mat-header-cell *matHeaderCellDef>SALES AFTER DISCOUNT</th>
    <td mat-cell *matCellDef="let row">{{ money(row.salesAfterDiscount) }}</td>
  </ng-container>
  <ng-container matColumnDef="averageSale">
    <th mat-header-cell *matHeaderCellDef>AVERAGE SALE</th>
    <td mat-cell *matCellDef="let row">{{ money(row.averageSale) }}</td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
